export enum HeaderSelectMenuItemsEnum {
  SECURITY = 'Security',
  LOGOUT = 'Logout',
}
